import { DEFAULT_BASE_SIZE } from './base-theme';

function calcSize(
  baseSize: number,
  ratio: number,
  minSize?: number | null | undefined,
  maxSize?: number | null | undefined
): number {
  const targetSize = ratio * baseSize;
  return Math.min(maxSize ?? 9999, Math.max(targetSize, minSize ?? 0));
}

export function getCalcSize(baseSize: number | null | undefined) {
  return function (
    ratio: number,
    minSize?: number | null | undefined,
    maxSize?: number | null | undefined
  ): number {
    return calcSize(baseSize || DEFAULT_BASE_SIZE, ratio, minSize, maxSize);
  };
}
